<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box">
					<label for="start-date">角色名称：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.roleName"  name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">编号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.code"  name="start-date"></span>
				</div>
			</div>
			<div class="order-query-form-box-right ">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="role-manage-wrap">
			<div class="role-manage-left stBgf">
				<div class="st-pos-search-box">
					<div class="st-pos-input">
						<span>角色设置</span>
					</div>
					<span class="st-pos-btn stFbgc" @click="createRoleBtn">新增</span>
				</div>
				<div class="data-table-box">
					<common-table ref="CommonTableRef" 
						:tableColumns="tableColumns" 
						:data="dataList" 
						:loading="false"
						:showPage="togglePage"
						:pageConfig="pageConfig"
						@currentChange="currentChange"
						@sizeChange="sizeChange">
					</common-table>
				</div>
			</div>
			<div class="role-manage-right stBgf">
				<div class="role-save-top clearfix">
					<div class="role-save-default fl">{{defaultRole}}</div>
					<div class="role-save-right fr">
						<span class="role-save-btn stMbgc" @click="saveRole">保存</span>
					</div>
				</div>
				<div class="role-manage-list-box">
					<div class="role-manage-list-warp">
						<el-tree
							:data="permissionTreeList"
							default-expand-all
							node-key="id"
							ref="tree"
							show-checkbox
							:default-checked-keys="checkList"
							check-strictly
							@check="hanleCheck"
							:props="defaultProps">
						</el-tree>
					</div>
				</div>
			</div>
		</div>
		<st-dialog title="新增角色"  :toggleStDialog="toggleStDialog" @closeDialog="toggleStDialog=false" @saveDialog="saveDialogForm">
			<div class="st-dialog-content">
				<ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title">编号：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="createRoleForm.code" ></div>
					</li>
					<li>
						<div class="st-dialog-item-title">名称：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="createRoleForm.name" ></div>
					</li>
				</ul>
			</div>
		</st-dialog>
	</div>
</template>
<script>
import stDialog from '../../components/StDialog'

export default {
	name: 'RoleManage',
	props: [],
	components: {stDialog},
	data() {
		return {
			tableColumns:[
				{
					key: '',
					title: '操作',
					align:'center',
					operate:true,
					setBtns:(row,index)=>{
						return [
							{
								label:'设置',
								style:"color:#32BB57;marginRight:30px",
								handler: (row,index) => this.setRole(row)
							},
							{
								label:'删除',
								handler: (row,index) => this.delRole(row.id)
							}
						]
					}
				},
				{
					title:'角色名称',
					align:'center',
					key:'name',
				}
			],
			pageConfig: {
				total: 0,
				pageSize: 100,
				currentPage: 1,
				layout: "total, sizes",
			},
			dataList:[], //订单列表
			setRoleId:null,// 设置的角色id
			tableHeight:null,
			orderForm:{
				roleName:null, //角色名
				code:null
			},
			
			togglePage:false, //是否显示分页
			toggleStDialog:false,// 弹窗
			defaultRole:'',//默认角色
			roleName:'',//  查询的角色名
			createRoleForm:{
				code:null,//添加的角色名
				name:null,//添加的角色名
			},
			checkList:[], //选中的权限
			permissionTreeList:[], // 权限树列表
			rolePermissionList:[],//角色的权限列表
			defaultProps: {
				children: 'children',
				label: 'name'
			}
		}
	},

	methods: {
		sizeChange(size) {
			this.pageConfig.currentPage = 1
			this.pageConfig.pageSize = size
			this.searchList()
		},
		currentChange(currentPage) {
			this.pageConfig.currentPage = currentPage
			this.searchList()
      	},
		searchList(flag){
			let pages={};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			if(flag) pages.current = 1;
			let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
			this.$server.role.getRole(orderForm,(res)=>{
				if(res.code==0){
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if(res.data.total>0){
						this.togglePage=true;
					}
				}
			})
		},
		
		// 显示创建弹窗
		createRoleBtn(){
			this.toggleStDialog=true;
			this.createRoleForm={
				code:null,
				name:null,
			}
		},
		// 创建角色
		saveDialogForm(){
			let that=this;
			let data=this.createRoleForm;
			this.$server.role.createRole(data,(res)=>{
				if(res.code==0){
					that.searchList();
					that.$toast.stMessage('创建成功',true)
					this.toggleStDialog=false;
					this.createRoleForm={brand_right:0};
				}else{
					that.$toast.stMessage(res.message,false)
				}
			})
		},
		// 获取权限树
		getPermissionTree(){
			return new Promise((resolve) => {
				this.$server.role.permissionTree((res)=>{
					if(res.code==0){
						resolve(res.data)
					}
				})
			})
		},
		// 获取角色权限
		async setRole(row){
			this.setRoleId=row.id;
			let checkList=[]
			let parentNodes=[]
			this.$server.role.permissionOfRole(row.id,(res)=>{
				if(res.code==0){
					if(res.data.length>0){
						res.data.forEach(item=>{
							checkList.push(item.id)
							if(item.parentId && parentNodes.indexOf(item.parentId)<0){
								parentNodes.push(item.parentId)
							}
						})
					}
					this.checkList=checkList
					this.rolePermissionList=res.data;
				}
			})
			
			this.defaultRole=row.name;
			this.permissionTreeList = await this.getPermissionTree();
		},
		// 删除角色
		delRole(roleId){
			let that=this;
			this.$server.role.removeRole(roleId,(res)=>{
				if(res.code==0){
					that.searchList();
					that.$toast.stMessage('删除成功',true)
					if(this.setRoleId==roleId){
						this.defaultRole='';
						this.permissionTreeList=[]
					}
				}else{
					that.$toast.stMessage(res.message,false)
				}
			})
		},
		// 设置权限
		saveRole(){
			let that=this;
			let data={};
			data.roleId=this.setRoleId;
			data.permissionId=this.$refs.tree.getCheckedKeys()//this.checkList;
			this.$server.role.setRolePermission(data,(res)=>{
				if(res.code==0){
					that.$toast.stMessage('设置成功',true)
				}else{
					that.$toast.stMessage(res.message,false)
				}
			})
		},
		hanleCheck(data,node){
			const  _this = this
			// 获取当前节点是否被选中
			const isChecked = this.$refs.tree.getNode(data).checked
			console.log(isChecked,data.parentId)
			// 如果当前节点被选中，则遍历上级节点和下级子节点并选中，如果当前节点取消选中，则遍历下级节点并取消选中
			if(isChecked){
				// 判断是否有上级节点，如果有那么遍历设置上级节点选中
				data.parentId &&  setParentChecked(data.parentId)
				// 判断该节点是否有下级节点，如果有那么遍历设置下级节点为选中
				data.children && setChildreChecked(data.children,true)
			}else{
			// 如果节点取消选中，则取消该节点下的子节点选中
				data.children && setChildreChecked(data.children,false)
			}
			function setParentChecked(parentId){
				// 获取该id的父级node
				const parentNode = _this.$refs.tree.getNode(parentId)
				// console.log(parentNode.data.parentId)
				// 如果该id的父级node存在父级id则继续遍历
				parentNode && parentNode.data.parentId && setParentChecked(parentNode.data.parentId)
				//  设置该id的节点为选中状态
				_this.$refs.tree.setChecked(parentId,true)
			}
			function setChildreChecked(node,isChecked){
				node.forEach(item => {
					item.children && setChildreChecked(item.children,isChecked)
					_this.$refs.tree.setChecked(item.id,isChecked)
				})
			}
			
		},
		
	},
	mounted() {
		this.searchList();
		
	}
}

</script>
<style scoped>
.role-manage {
	width: 100%;
	height: auto;
}
.query-setting-box-left{
	flex-grow: 0;
}
.role-manage-wrap{
	display: flex;
	justify-content: space-between;
	flex-grow: 1;
}
.role-manage-left{
	width: 547px;
	padding: 8px;
	overflow: hidden;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	position: relative;
}

.st-pos-search-box{
	display: flex;
	padding: 8px 0;

}
.st-pos-input {
	flex: 1;
	
}
.st-pos-input input{
	height: 30px;
	border: none;
	outline: none;
}
.st-pos-btn{
	display: inline-block;
	width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    border-radius: 2px;
    cursor: pointer;
    margin-left: 8px;
}
.role-manage-right{
	width: 1253px;
	padding: 8px 32px 0 24px;
	overflow: hidden;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}
.role-save-top{
	padding: 8px 0;
	border-bottom: 1px solid #D8D8D8;
	height: 30px;
	width: 100%;
}
.role-save-default{
	color: #FF5B3E;
	width: 500px;
	height: 30px;
	line-height: 30px;
}
.role-save-right{
	display: flex;
	width: auto;
}
.role-save-input{
	width: 140px;
	height: 30px;
	margin-right: 16px;
	
}
.role-save-input input{
	width: 140px;
	height: 30px;
	border: 1px solid #DCDCDC;
	border-radius: 2px;
	text-indent: 8px;
	box-sizing: border-box;
}
.role-save-btn{
	display: inline-block;
	width: 80px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	color: #fff;
	border-radius: 2px;
	cursor: pointer;
	margin-left: 8px;
}
.role-manage-list-box{
	padding: 8px 0;
	flex:1;
	position: relative;
}
.role-manage-list-warp{
	position: absolute;
	left: 0;
	top: 8px;
	right: 0;
	bottom: 8px;
	overflow: auto;
}
.role-manage-list-type{
	padding-bottom: 12px;
}
.role-manage-list-title{
	font-size: 14px;
	color: #B5B5B5;
}
.role-manage-list-type .el-checkbox{
	height: 40px;
	line-height: 40px;
}
.setRole{
	display: inline-block;
	width: 80px;
	height: 32px;
	line-height: 32px;
	color: #32BB57;
	margin-left: 40px;
	margin-right: 20px;
	cursor: pointer;
}
.delRole{
	display: inline-block;
	width: 80px;
	height: 32px;
	line-height: 32px;
	color: #FF5B3E;
	cursor: pointer;
}
.st-dialog-form{
	padding: 30px 0;
}

/* 弹窗内 */
	/*  */
	.st-dialog-content {
		min-height: 200px;
		padding: 0 32px;
	}

	.st-dialog-form {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
	}

	.st-dialog-form li {
		width: 156px;
		padding: 13px 0;
	}

	.st-dialog-form li:nth-child(even) {
		float: right;
	}

	.st-dialog-form li:nth-child(odd) {
		float: left;
	}

	.st-dialog-form .st-dialog-item-title {
		height: 20px;
		line-height: 20px;
	}

	.st-dialog-form .st-dialog-item-title i {
		color: #FF5B3E;
	}

	.st-dialog-form .st-dialog-item-input input {
		width: 156px;
		height: 30px;
		text-indent: 8px;
		border-radius: 2px;
		border: 1px solid #DCDCDC;
		box-sizing: border-box;
	}

	.setConfig {
		cursor: pointer;
	}

	/* end */

@media only screen and (max-width: 1366px) {
	.role-manage-left {
		width: 378px;
	}
	.setRole{
		width: 70px;
		margin-left: 20px;
		margin-right: 10px;
	}
	.delRole{
		width: 70px;
	}
	.role-manage-right {
		width: 868px;
	}
}
</style>
